import { z } from 'zod';
import { TokenTypeKey } from './token-setting.model';

export enum AllocationTypeKey {
  IN_PLAN = 'in_plan',
  CUSTOMER_PURCHASE = 'customer_purchase',
  COMPLIMENTARY = 'complimentary',
}

export type AllocationType = {
  key: AllocationTypeKey;
  name: string;
  description: string;
};

export class AllocationTypes {
  static readonly IN_PLAN: AllocationType = {
    key: AllocationTypeKey.IN_PLAN,
    name: 'In Plan',
    description: 'In Plan allocation',
  };
  static readonly CUSTOMER_PURCHASE: AllocationType = {
    key: AllocationTypeKey.CUSTOMER_PURCHASE,
    name: 'Customer Purchase',
    description: 'Customer Purchase allocation',
  };
  static readonly COMPLIMENTARY: AllocationType = {
    key: AllocationTypeKey.COMPLIMENTARY,
    name: 'Complimentary',
    description: 'Complimentary allocation',
  };
}

export const TokenAllocationSchema = z.object({
  id: z.number(),
  token_type: z.enum(TokenTypeKey),
  allocated_amount: z.number(),
  allocation_remaining: z.number(),
  created_at: z.string(),
  valid_from: z.string(),
  valid_to: z.string(),
  allocation_type: z.enum(AllocationTypeKey),
});

export type TokenAllocation = z.infer<typeof TokenAllocationSchema>;
